module.exports = __webpack_public_path__ + "static/media/griffithcollege.fd1a16d0.png";